@if (tags()?.length) {
  <div class="flex flex-wrap space-x-2.5">
    @for (tag of tags(); track tag; let i = $index) {
      <div class="flex items-center px-2.5 py-0.5 rounded bg-white border-2 border-slate-200">
        {{tag}}
        <button type="button" (click)="remove.emit(tag)">
          <svg class="w-4 h-4 ml-1.5">
            <use xlink:href="assets/icons/symbols.svg#close"></use>
          </svg>
        </button>
      </div>
    }
  </div>
}
